// extracted by mini-css-extract-plugin
export default {"budget":"Budget_budget__3eU2V","heading":"Budget_heading__8jkBt"};